import { Injectable } from '@angular/core';
import { HttpServiceBundle } from '@app/core/services/base/http-service-bundle.service';
import { Observable } from 'rxjs';
import { BaseHttpWithBundleService } from '@app/core/services/base/base-service-with-bundle.service';
import { map } from 'rxjs/operators';
import { PaginatedList } from '@app/shared/models/list';
import { BackendUriUnits } from '@app/core/services/base/backend-uri-units';
import { SMPLog } from '@app/shared/models/log';
import { DRResponse } from '@app/shared/models/response';
import { TimePeriod } from '@app/shared/models/time-period';
import { DrI18nService } from '@app/core/services/i18n/i18n.service';
import { TranslationEntry } from '@app/shared/models/translatable';


@Injectable({ providedIn: 'root' })
export class LogService extends BaseHttpWithBundleService {

    constructor(httpServiceBundle: HttpServiceBundle, protected drI18nService: DrI18nService) {
        super(httpServiceBundle, true);
        // Setting a new uri because this is not an SMP call
        this.uri += `/${BackendUriUnits.CLIENTS}/${BackendUriUnits.JOURNAL}`;
    }

    public getLogCategories(): Observable<TranslationEntry[]> {
        const uri = `${this.uri}/categories`;
        const params = {
            locale: DrI18nService.getActiveLocaleInformation().shortName
        };

        return this.http.get<DRResponse<any>>(uri, { params: params })
                        .pipe(map(result => {
                            return Object.entries(result.data)
                                                  .map(([key, value]) => {
                                return { key: key, trans: value as string };
                            });
                        }));
    }

    public getClientLogs(categoryKey?: string, userId?: string, search?: string, date?: Date,
                         timePeriod: TimePeriod = TimePeriod.TODAY,
                         locale: string = DrI18nService.getActiveLocaleInformation().shortName): Observable<PaginatedList<SMPLog>> {
        const params: any = {
            locale: locale,
            timePeriod: timePeriod,
        };

        if (categoryKey) {
            params.category = categoryKey;
        }

        if (userId) {
            params.userId = userId;
        }

        if (search) {
            params.search = search;
        }

        if (date) {
            params.date = DrI18nService.dateTimeToDateOnlyString(date);
        }

        return this.http.get<DRResponse<PaginatedList<SMPLog>>>(this.uri, { params: params })
                        .pipe(map(res => new PaginatedList(SMPLog, res.data, 'logs')));
    }

}
